import Field from "../../../shared/ui/Field/Field";
import GeoRegionSelect from "./GeoRegionSelect";
import GeoSettlementAutocomplete from "./GeoSettlementAutocomplete";
import {
  applyRegionSelection,
  applySettlementSelection,
} from "../lib/locationGeo";
import { buildHierarchyRows } from "../lib/locationPresentation";
import "./geoLocationFields.css";

// Shared canonical geography controls for create + edit location forms.

function CanonicalHierarchySummary({ unit, idPrefix }) {
  const rows = buildHierarchyRows(unit);
  if (!rows.length) return null;

  const headingId = `${idPrefix}-geo-hierarchy-heading`;

  return (
    <section
      className="geo-hierarchy-summary"
      aria-labelledby={headingId}
      data-testid="geo-hierarchy-summary"
    >
      <h3 id={headingId} className="geo-hierarchy-summary__title">
        Обрана географія
      </h3>
      <ol className="geo-hierarchy-summary__list">
        {rows.map((row) => (
          <li
            key={row.code || row.displayLine}
            className="geo-hierarchy-summary__item"
          >
            <span className="geo-hierarchy-summary__line">{row.displayLine}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}

function LocationCanonicalFields({
  values,
  onChange,
  fieldErrors = {},
  idPrefix = "loc",
}) {
  const isKRegion = values.selectedRegion?.category === "K";
  const settlementEnabled = Boolean(
    values.selectedRegion && values.selectedRegion.category === "O",
  );

  const handleRegionChange = (region) => {
    onChange(applyRegionSelection(values, region));
  };

  const handleSettlementSelect = (settlement) => {
    onChange(applySettlementSelection(values, settlement));
  };

  return (
    <>
      <div
        className="ap-row ap-row--2 geo-canonical-fields"
        data-testid="geo-canonical-fields"
      >
        <div className="ap-field geo-canonical-field">
          <Field
            id={`${idPrefix}-canonical-region`}
            label="Область / місто зі спеціальним статусом"
            help="Оберіть область або місто зі спеціальним статусом."
            error={fieldErrors.canonical_region}
            required
            className="geo-canonical-field__field"
          >
            <GeoRegionSelect
              id={`${idPrefix}-canonical-region`}
              value={values.selectedRegion}
              onChange={handleRegionChange}
              required
            />
          </Field>
        </div>
        <div className="ap-field geo-canonical-field">
          <GeoSettlementAutocomplete
            id={`${idPrefix}-canonical-settlement`}
            regionCode={values.selectedRegion?.code}
            enabled={settlementEnabled}
            selectedSettlement={values.selectedSettlement}
            onSelect={handleSettlementSelect}
            error={fieldErrors.canonical_settlement}
            disabled={!values.selectedRegion || isKRegion}
          />
          <div className="geo-canonical-field__notices" aria-live="polite">
            {isKRegion && values.selectedSettlement ? (
              <small className="form-hint">
                {values.selectedSettlement.name} (місто зі спеціальним статусом)
              </small>
            ) : null}
            {values.selectedSettlement && !values.selectedSettlement.is_active ? (
              <small className="form-hint text-warning">
                Обраний населений пункт неактивний у довіднику КАТОТТГ.
              </small>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export { CanonicalHierarchySummary };
export default LocationCanonicalFields;
